import { DateTimeFormat } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../utils/getCurrentLocale'
import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableDueDateCellProps {
  row: BillsTableRow
}

export const BillsTableDueDateCell = ({ row }: BillsTableDueDateCellProps): ReactElement => {
  const locale = getCurrentLocale()

  if (isBillsTableFieldSuggestion(row.dueDate)) {
    return <BillsTableSuggestedField value={DateTimeFormat.getFormattedDate(row.dueDate.suggestion, locale)} />
  }

  if (row.dueDate.actual === null) {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{DateTimeFormat.getFormattedDate(row.dueDate.actual, locale)}</Typography.Text>
}
